import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { CTA_URL, IMAGES, NAV_LINKS } from "../constants";

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "border-b border-transparent bg-white/90 backdrop-blur-md md:border-zinc-200"
          : "border-b border-transparent bg-gradient-to-r from-black/40 via-zinc-800/25 to-brand-pink/20 backdrop-blur-sm md:border-white/20"
      } animate-fade-in`}
    >
      <div className="mx-auto flex h-[4.5rem] w-full max-w-7xl items-center justify-between px-4 sm:px-6 lg:h-20 lg:px-8">
        <a href="#inicio" className="inline-flex items-center">
          <img
            src={IMAGES.logo}
            alt="Logo AsiViajo"
            className="h-14 w-auto sm:h-16 md:h-[4.5rem]"
          />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              className={`text-xs font-semibold uppercase tracking-[0.1em] transition ${
                isScrolled
                  ? "text-zinc-700 hover:text-brand-pink"
                  : "text-white/95 [text-shadow:0_1px_6px_rgba(0,0,0,0.35)] hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <a
          href={CTA_URL}
          className="hidden rounded-lg bg-brand-pink px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.08em] text-white transition hover:bg-brand-pink-dark md:inline-flex"
        >
          Preinscripción
        </a>

        <button
          type="button"
          className={`inline-flex p-2 md:hidden ${
            isScrolled ? "text-zinc-900" : "text-white"
          }`}
          onClick={() => setIsOpen((value) => !value)}
          aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
        >
          {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      <div
        className={`overflow-hidden border-t border-zinc-200 bg-white transition-all duration-300 md:hidden ${
          isOpen ? "max-h-80" : "max-h-0"
        }`}
      >
        <div className="space-y-1 px-4 py-4">
          {NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className="block py-2 text-sm font-medium text-zinc-700"
            >
              {link.label}
            </a>
          ))}
          <a
            href={CTA_URL}
            onClick={() => setIsOpen(false)}
            className="mt-3 block rounded-lg bg-brand-pink px-4 py-3 text-center text-xs font-semibold uppercase tracking-[0.08em] text-white"
          >
            Solicitar Preinscripción
          </a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
